import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapTariffGroupOptions = (
  option: UCM.ContractTariffGroupOptionRawType,
): UCM.ContractTariffGroupOptionType => ({
  value: option.code,
  label: option.name,
});

const getTariffGroupOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.ContractTariffGroupOptionRawType>
  >(API.GET.contractTariffGroupOptions, {
    headers: { Accept: 'application/vnd.falcon.v2+json' },
  });
  return data.data.map(({ attributes }) => mapTariffGroupOptions(attributes));
};

export const useGetTariffGroupOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CONTRACT_TARIFF_GROUP_OPTIONS],
    queryFn: getTariffGroupOptions,
    staleTime: 1000 * 60 * 10,
    ...config,
  });
};
